import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

const SharedModal = ({
  isOpen,
  title,
  size,
  onClose,
  onDelete,
  onOkay,
  children,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
    onClose();
  };

  return (
    <Modal centered show={isOpen} onHide={onClose} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Cancel
        </Button>
        {onDelete && (
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        )}
        {onOkay && (
          <Button variant="danger" onClick={onOkay}>
            Okay
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SharedModal;
